<template>
  <div>
    <el-dialog
      v-if="visible"
      :title="title"
      :visible="visible"
      width="1000px"
      show-close
      :close-on-click-modal="false"
      append-to-body
      :before-close="() => $refs.editForm.cancel()"
    >
      <EditForm
        ref="editForm"
        @close="close()"
        @reload="$emit('reload')"
        :disabled="disabled"
        :funcID="funcID"
        :labelKey="labelKey"
        :isEdit="isEdit"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="$refs.editForm.saveContinue()"
          v-if="disabled ? false : !isEdit"
        >
          {{ '保存后继续创建下一个' }}
        </el-button>
        <el-button
          size="small"
          type="warning"
          @click="$refs.editForm.saveClose()"
          v-if="disabled ? false : !isEdit"
        >
          {{ '保存后关闭' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="disabled ? false : isEdit"
          @click="$refs.editForm.saveClose()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditForm from './index.vue'
export default {
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    funcID: { type: String, default: '' },
    labelKey: { type: String, default: '' },
  },
  computed: {
    isEdit() {
      return !!this.funcID && !!this.labelKey
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
